import React from "react";
import ReactDOM from "react-dom/client";
// Font packages imported here (not via CSS @import) so Vite bundles their
// woff2 files into the production build — see the note in index.css.
import "@fontsource-variable/figtree";
import "@fontsource-variable/jetbrains-mono";
import { App } from "./app/app";
import { installClientErrorHandlers } from "./shared/lib/error-reporter";
import "./index.css";

// Ставится до первого рендера: сбой при монтировании — тоже сбой, о котором
// надо узнать.
installClientErrorHandlers();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
